/* global document */

import ReactDOM from 'react-dom';

import Widget from './Widget';

const DarioushReceiptWidget = () =>
  ReactDOM.createPortal(
    <Widget />,
    document.getElementById('c7-darioush-receipt')
  );

export default DarioushReceiptWidget;
